import { ICargo } from '../entities/cargoes'
import { cargoes } from '../entities/cargoes-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createConsumeCargoTask } from './taskConsumeCargo'
import { createTask_custom } from './taskCustom'
import { createFetchCargoTask } from './taskFetchCargo'

export const register = () => registerJob('eat', runJob_eat)

const falseFilter = () => false
const foodFilter = (f: ICargo) => f.data.type === 'food'

export function runJob_eat(job: IJob) {
  jobLogger.assertJobType(job, 'eat')
  let m = jobLogger.assertReserved(job)

  if (!job.cargoFilter) {
    job.cargoFilter = foodFilter
  }

  if (jobLogger.runTasks(job)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  if (m.statHunger > 50) {
    return jobLogger.succeedJob(job)
  }

  if (m.carryingCargo && job.cargoFilter(m.carryingCargo)) {
    // Consume
    job.tasks.push(createConsumeCargoTask(m.i, m.j, m.carryingCargo.data.type))

    job.tasks.push(
      createTask_custom(m.i, m.j, (t) => {
        m.statHunger += 100
        jobLogger.succeedTask(job, t)
      }),
    )

    return
  }

  let closestFood = cargoes.findClosestTo(
    m.i,
    m.j,
    job.cargoFilter || falseFilter,
  )
  if (!closestFood) {
    return jobLogger.failJob(job, 'no food')
  }

  // Go to cargo
  job.tasks.push(createFetchCargoTask(m.i, m.j, job.cargoFilter, null, true))
}
// export function advanceJob_moveToStack(job: IJob) {}
